import { render, staticRenderFns } from "./DialogDiscount.vue?vue&type=template&id=5127700b&"
import script from "./DialogDiscount.vue?vue&type=script&lang=js&"
export * from "./DialogDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports